import LanguageSwitcher from './LanguageSwitcher';

/**
 * Fixed-position language switcher for pages that don't render the global
 * Header (components/Header.tsx) — e.g. auth pages, certificate verification.
 * Sits in the top-right corner with a z-index above page content but below
 * modal overlays.
 */
export default function FloatingLanguageSwitcher() {
  return (
    <div className="fixed top-4 right-4 z-40">
      <LanguageSwitcher variant="desktop" />
    </div>
  );
}
